import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { ArbitrationTableHeading } from "../../Utils/appConstants";
import SortIcon from "../../assets/WebFont/sort.svg";
import { TableSortLabel } from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getArbitrationList } from "../../service/api";
import { Box } from "@material-ui/core";
import Loaderpage from "../../pages/LoaderPage";

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeadFont: {
    fontWeight: 600,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
});


export default function ArbitrationComponent(props) {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('vin');
  const [arbitrationList, setArbitrationList] = useState([]);
  const [loader, setLoader] = useState(true);
  const handleRequestSort = (
    property
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }


  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  useEffect(async () => {
    setLoader(true)
    const arbitrationListData = await getArbitrationList();
    console.log('arbitrationListData', arbitrationListData)
    setArbitrationList(arbitrationListData?.data)
    setLoader(false)
  }, []);
  // console.log('arbi', arbitrationList)

  useEffect(() => {
    if (arbitrationList.length > 0) {
      const updatedData = stableSort(arbitrationList, getComparator(order, orderBy));
      setArbitrationList(updatedData);
    }
  }, [order, orderBy]);
  
  const openArbitrationReview = (item) => {
    props.history.push("/arbitrationReview", {
      item,
      pageName: "Arbitration Review",

    });
  };

  return (
    <div style={{ marginTop: '50px' }}>
      <AppBar position="inherit" className='topBarAdmin'>
        <Tabs value={0} aria-label="simple tabs example" className='tabset'>
          <Tab label="Arbitration List" />
        </Tabs>
      </AppBar>
      <div>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont}>
                {ArbitrationTableHeading.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === item.id}
                        direction={orderBy === item.id ? order : 'asc'}
                        onClick={() => handleRequestSort(item.id)}
                        IconComponent={() => (
                          <img src={SortIcon} alt="sort" className="tableSortIcon" />
                        )}
                      >
                        {item.label}
                      </TableSortLabel>
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {arbitrationList && arbitrationList
                ?.map((row, index) => (
                  <TableRow key={index} className={classes.tableRow}>
                    <TableCell>
                      <span className="textStyle">
                        <a href
                          className="vin"
                          onClick={() => openArbitrationReview(row)}
                        >
                          {" "}
                          {row.arbitration_id}
                        </a>
                      </span>
                    </TableCell>
                    <TableCell>{row.vin}</TableCell>
                    <TableCell>{row.dealer}</TableCell>
                    <TableCell>{row.model_year}</TableCell>
                    <TableCell>{row.brand}</TableCell>
                    <TableCell>{row.modeltrim}
                     </TableCell>
                    <TableCell>{row.ext_color}
                      </TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell>{row.arbitration_date}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
          {loader ? (
            <Box
              height={"350px"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <div>
                <Loaderpage />
                <span className="loaderText">Loading...</span>
              </div>
            </Box>
          ) : (
            ""
          )}
        </div>
      </div>
  );
}
